import { Pipe, PipeTransform } from '@angular/core';
import { CourseParticipationStatus } from '../../../../../../shared/interfaces/src';

@Pipe({ name: 'courseParticipationStatusEnum' })
export class CourseParticipationStatusEnumPipe implements PipeTransform {
    transform(status: CourseParticipationStatus): string {
        switch (status) {
            case CourseParticipationStatus.EDUCATION_MODULE_1:
                return 'Modul I';
            case CourseParticipationStatus.EDUCATION_MODULE_2:
                return 'Modul II';
            case CourseParticipationStatus.EDUCATION_MODULE_3:
                return 'Modul III';
            case CourseParticipationStatus.EDUCATION_MODULE_4:
                return 'Modul IV';
            case CourseParticipationStatus.EDUCATION_REPETITORIUM:
                return 'Repetitorium';
            case CourseParticipationStatus.EDUCATION_DONE:
                return 'Abgeschlossen';
            case CourseParticipationStatus.TRAINING_IN_PROGRESS:
                return 'Fortbildung in Arbeit';
            case CourseParticipationStatus.TRAINING_DONE:
                return 'Fortbildung Beendet';
            default:
                return 'Kein Status';
        }
    }
}
